import { lazy, Suspense } from "react";
import type { CollaborationInputProps } from "./collaboration-input";

// Lazy load the CollaborationInput component to reduce initial bundle size
// This component uses Lexical editor which is a heavy dependency
const LazyCollaborationInput = lazy(() =>
  import("./collaboration-input").then((module) => ({
    default: module.CollaborationInput,
  }))
);

// Skeleton loader that matches the CollaborationInput dimensions
const CollaborationInputSkeleton = () => (
  <div className="relative">
    <div
      className="h-[88px] border border-neutral-200 rounded-lg bg-gray-50 animate-pulse"
      aria-label="Loading comment editor..."
    />
  </div>
);

/**
 * Lazy-loaded wrapper for CollaborationInput
 * Use this component instead of importing CollaborationInput directly to improve bundle size
 */
export function CollaborationInputLazy(props: CollaborationInputProps) {
  return (
    <Suspense fallback={<CollaborationInputSkeleton />}>
      <LazyCollaborationInput {...props} />
    </Suspense>
  );
}
